import React from "react";
import { Helmet } from 'react-helmet';
import { useLocation } from "react-router-dom";

const facilities = [
  {
    title: "Room Service",
    description: "Enjoy 24/7 in-room dining with comfort, convenience, and a wide selection of freshly prepared meals.",
    icon: "/images/amenities/new/icon/room-service_.png",
    img: "/images/amenities/new/room-service_.jpg"
  },
  {
    title: "Pick & Drop",
    description: "Enjoy hassle-free travel with our complimentary airport pick-up and drop-off service.",
    icon: "/images/amenities/new/icon/pickup and drop_.png",
    img: "/images/amenities/new/pickupanddrop_.jpg"
  },
  {
    title: "WiFi",
    description: "Stay connected with high-speed wireless internet access available across the hotel.",
    icon: "/images/amenities/new/icon/wifi_.png",
    img: "/images/amenities/new/wifi_.jpg"
  },
  {
    title: "Breakfast",
    description: "Start your day with a gourmet breakfast buffet featuring a variety of local and international dishes.",
    icon: "/images/amenities/new/icon/breakfast_.png",
    img: "/images/amenities/new/breakfast_.jpg"
  },
  {
    title: "Swimming Pool",
    description: "Take a refreshing dip in our serene pool area, perfect for relaxation and leisure.",
    icon: "/images/amenities/new/icon/swimming-pool_.png",
    img: "/images/amenities/new/swimming-pool_.jpg"
  },
  {
    title: "Parking Space",
    description: "Avail of our secure on-site parking for all your vehicular needs.",
    icon: "/images/amenities/new/icon/parking-space_.png",
    img: "/images/amenities/new/paking-space_.jpg"
  },
  {
    title: "Wheel Chair",
    description: "We provide wheelchairs for guests with mobility challenges to ensure a comfortable stay.",
    icon: "/images/amenities/new/icon/wheel-chair_.png",
    img: "/images/amenities/new/wheel-chair_.jpg"
  },
  {
    title: "Aero Stag",
    description: "Immerse yourself in a unique culinary experience at Aerostag Restaurant, where poolside dining meets refined ambiance.",
    icon: "/images/amenities/new/icon/aero-stag_.png",
    img: "/images/amenities/new/aero-stag_.jpg"
  },
];

const Amenities = () => {

  return (
    <>
  

      <div className="facilities-container">
        <h2 className="facilities-title">AMENITIES</h2>
        <div className="facilities-grid">
          {facilities.map((item, index) => (
            <div
              key={index}
              className="facility-card"
              style={{
                background: `url(${item.img})`,
                backgroundSize: "cover",
                backgroundPosition: "center"
              }}
            >
              <div className="facility-icon">
                <img
                  src={item.icon}
                  alt={`V Hotel The Grand Shoba - Free ${item.title}`}
                  title={`V Hotel The Grand Shoba Amenities - ${item.title}`}
                  height={90}
                  width={90}
                />
              </div>
              <h3 className="facility-title">{item.title}</h3>
              <p className="facility-description">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Amenities;
